import axios from 'axios';

import type { SubmitError } from './errorClassification.types';

const GENERIC_FAILURE: SubmitError = {
  headline: 'Something went wrong.',
  body: "We Couldn't submit your form. Please try again later",
  retryable: true,
};

export const classifyError = (error: Error): SubmitError => {
  if (!axios.isAxiosError(error)) return GENERIC_FAILURE;

  if (!error.response) {
    return {
      headline: 'Submission failed.',
      body: 'Please check your connection and try again.',
      retryable: true,
    };
  }

  const status = error.response.status;
  if (status >= 400 && status < 500) {
    return { headline: 'Invalid input.', body: 'Please review your details.', retryable: false };
  }

  return GENERIC_FAILURE;
};
